// extracted by mini-css-extract-plugin
module.exports = {"container":"user-menu_container__bPO3d","setting-button":"user-menu_setting-button__kXxnj","avatar":"user-menu_avatar__e7e4I"};